(function($) {
  /**
	 * Easy Bootstrap Collapse
	 * @since 2019-05
	 */
	$(document).on('click', '.collapse-auto', function() {
		var $btn = $(this);
		var $con = $btn.parent().find('.collapse');

		if (!$con.hasClass('show')) {
			$btn.removeClass('collapsed');
			$con.collapse('show');
		} else {
			$btn.addClass('collapsed');
			$con.collapse('hide');
		}
	});
})(jQuery);